import LegalPageLayout from "@/pages/LegalPageLayout";
import { Link } from "wouter";

export default function Terms() {
  return (
    <LegalPageLayout title="Terms of Service: Home, Twice">
      <p>By using app.kwadernoco.com (&quot;the App&quot;) or buying a Home, Twice journal, you agree to these terms.</p>

      <section className="legal-section">
        <h2>The service</h2>
        <p>Home, Twice is a printed guided journal with QR codes that link to voice pages, where you can record audio answers to the prompts in the book.</p>
      </section>

      <section className="legal-section">
        <h2>Your account</h2>
        <p>You need a valid email address to sign in, and you must be an adult (18, or the age of majority where you live). Keep your sign-in codes and share links private. You&apos;re responsible for what&apos;s recorded or shared from your account.</p>
      </section>

      <section className="legal-section">
        <h2>Your content</h2>
        <p>You own your recordings. By using the App, you give us a limited license to store, process, and transmit them only as needed to run the service (saving, playback, and sharing if you turn it on). We don&apos;t use your recordings for any other purpose. You&apos;re responsible for having permission from anyone whose voice is in a recording.</p>
      </section>

      <section className="legal-section">
        <h2>Acceptable use</h2>
        <p>Don&apos;t use the service to record or share anything illegal, or anything that infringes someone else&apos;s rights. We may remove content or suspend accounts that break these terms.</p>
      </section>

      <section className="legal-section">
        <h2>Sharing</h2>
        <p>Anyone with a share link can listen to that recording without an account. You control whether sharing is on, and you can turn it off at any time. We aren&apos;t responsible for what happens after you give a link to someone.</p>
      </section>

      <section className="legal-section">
        <h2>Deleting your content</h2>
        <p>You can delete a recording or your account at any time in the App, or by emailing <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a>. Recording a new version of a page replaces the previous one. How we handle deletion is described in our <Link href="/privacy">Privacy Policy</Link>.</p>
      </section>

      <section className="legal-section">
        <h2>No guarantee of permanence</h2>
        <p>We do our best to keep your recordings safe and available. If a recording is important to you, email us and we&apos;ll send you a copy of what we have stored. We aren&apos;t liable for data loss caused by circumstances outside our reasonable control.</p>
      </section>

      <section className="legal-section">
        <h2>Purchases</h2>
        <p>Journals bought from our own online store are covered by that store&apos;s shipping and refund policies. Journals bought through Etsy, Amazon, or Lulu are governed by that platform&apos;s terms.</p>
      </section>

      <section className="legal-section">
        <h2>Limitation of liability</h2>
        <p>The App is provided &quot;as is.&quot; To the extent the law allows, Kwaderno &amp; Co. is not liable for indirect or consequential damages from your use of the service. Nothing in these terms limits any rights you have under consumer protection laws that can&apos;t be waived.</p>
      </section>

      <section className="legal-section">
        <h2>Changes</h2>
        <p>We may update these terms from time to time. If you keep using the App after a change, you accept the new terms.</p>
      </section>

      <section className="legal-section">
        <h2>Governing law</h2>
        <p>These terms are governed by the laws of Ontario, Canada.</p>
      </section>

      <p>Contact: <a href="mailto:hello@kwadernoco.com">hello@kwadernoco.com</a></p>
    </LegalPageLayout>
  );
}
